import pathsManifest from './pathsManifest';
import DevPage from './components/pages/DevPage';
import DashboardPage from './components/pages/DashboardPage';
import TermsPage from './components/pages/TermsPage';
import NativeAppSignInPage from './components/pages/NativeAppSignInPage';
import WaitlistConfirmationPage from './components/pages/WaitlistConfirmationPage';
import NotFoundPage from './components/pages/NotFoundPage';

/*
 * NOTE: if you are planning to use AuthCheck with the requireStrongAuthentication prop set to TRUE
 * you must include the pageWithSensitiveInformation prop on the associated route
 * this ensures the correct api call is made on the server for user information
 */

const routes = [
  {
    exact: true,
    strict: false,
    component: DevPage,
    path: '/',
  },
  {
    exact: true,
    component: DashboardPage,
    path: pathsManifest.dashboard,
  },
  {
    component: TermsPage,
    path: pathsManifest.termsPage + '(/)?([?].*)?',
  },
  {
    pageWithSensitiveInformation: true,
    component: NativeAppSignInPage,
    path: pathsManifest.nativeAppSignInPage + '(/)?([?].*)?',
  },
  {
    exact: true,
    component: WaitlistConfirmationPage,
    pageWithSensitiveInformation: true,
    path: pathsManifest.waitlistConfirmationPage + '(/)?([?].*)?',
  },
  {
    component: NotFoundPage,
    path: '*',
  },
];

export default routes;
